import store from '../../store'

export default function (to, from, next) {
  const { defaultLocale, currentLocale } = store.state;

  const redirectWithLangPrefix = (!to.params.lang && currentLocale !== defaultLocale)
    || (to.params.lang && to.params.lang !== currentLocale);

  if (redirectWithLangPrefix) {
    let name = to.name
    if (name.endsWith('-double')) {
      name = name.replace('-double', '')
    }

    return next({
      name,
      params: {
        ...to.params,
        lang: currentLocale,
      },
      query: { ...to.query },
    });
  }

  // debugger
  // const lang = to.params.lang
  // // console.log('beforeEnterRoot')
  //
  // if (
  //   store.state.currentLocale !== lang &&
  //   store.state.locales.hasOwnProperty(lang)
  // ) {
  //   store.dispatch('setCurrentLocale', lang)
  // }
  //
  // if (!store.state.locales.hasOwnProperty(lang)) {
  //   const currentLang = store.state.currentLocale || Object.keys(store.state.locales)[0]
  //   let path = to.fullPath
  //
  //   if (!path.startsWith('/')) {
  //     path = '/' + path
  //   }
  //   if (!path.endsWith('/')) {
  //     path = path + '/'
  //   }
  //
  //   if (path.startsWith(`/${currentLang}/`)) {
  //     return next()
  //   }
  //
  //   path = '/' + currentLang + path
  //
  //   if(store.state.currentLocale !== currentLang) {
  //     store.dispatch('setCurrentLocale', currentLang)
  //   }
  //
  //   return next(path)
  // }

  next();
}
